import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import HeroDashboardPreview from "./HeroDashboardPreview";

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden px-6 pb-16 pt-20 md:px-10">
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_20%_20%,rgba(99,102,241,0.25),transparent_35%),radial-gradient(circle_at_80%_20%,rgba(20,184,166,0.22),transparent_35%)]" />
      <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-2 lg:items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <p className="mb-4 inline-flex rounded-full border border-indigo-100 bg-white px-3 py-1 text-xs font-semibold text-indigo-600 shadow-sm">
            AI Health Intelligence Platform
          </p>
          <h1 className="mb-5 text-4xl font-bold leading-tight text-gray-900 md:text-6xl">
            Turn Your Health Reports Into Clear Insights Instantly
          </h1>
          <p className="mb-8 max-w-xl text-lg text-gray-600">
            Upload reports. Let AI analyze. Track your health in one timeline.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <Link
              to="/upload"
              className="rounded-2xl bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-indigo-300/40 transition hover:-translate-y-0.5 hover:bg-indigo-500"
            >
              Upload Your Report
            </Link>
            <a
              href="#how-it-works"
              className="rounded-2xl border border-gray-200 bg-white px-6 py-3 text-sm font-semibold text-gray-700 transition hover:border-indigo-200 hover:text-indigo-600"
            >
              See How It Works
            </a>
          </div>
        </motion.div>

        <HeroDashboardPreview />
      </div>
    </section>
  );
}
